import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable } from '@angular/core';
import { identity } from 'rxjs';
import { map } from 'rxjs/operators';
// //produccion
// // import { environment } from 'src/environments/environment.prod';
// //desarrollo
import { environment } from 'src/environments/environment';
import { Vtiger_WSClient } from './WSClient';

@Injectable({
  providedIn: 'root',
})

export class VtigerService {
  private sessionid?: string = localStorage.getItem('sessionid');
  private serviceUser?: string = localStorage.getItem('serviceUser');
  private serviceKey?: string = localStorage.getItem('serviceKey');
  wsclient = new Vtiger_WSClient(this.wsUrl);

  constructor(private http: HttpClient) {
    this.wsclient._sessionid = this.sessionid;
  }

  login(user: string, pass: string): Promise<any> {
    this.serviceUser = user;
    this.serviceKey = pass;
    localStorage.setItem('serviceUser', user);
    localStorage.setItem('serviceKey', pass);

    return new Promise((resolve) => {
      this.wsclient.doLogin(user, pass, (res: any) => {
        if (res) {
          localStorage.setItem('contactid', '12x' + this.wsclient._contactid);
          localStorage.setItem('userid', this.wsclient._userid);
          localStorage.setItem('sessionid', this.wsclient._sessionid);
          resolve({ success: res, sessionid: this.wsclient._sessionid });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      });
    });
  }
  testSession(): Promise<any> {
    return new Promise((resolve) => {
      this.wsclient.doDescribe('Contacts', (res: any) => {
        if (res) resolve({ success: true });
        else resolve({ success: false });
      });
    });
  }

  reLogin(): Promise<any> {
    if (!this.serviceUser || !this.serviceKey) {
      return Promise.reject('No user credentials available');
    }

    return this.login(this.serviceUser, this.serviceKey);
  }

  getSessionId(): string | undefined {
    return this.sessionid;
  }
  
  describeModules() {
    return new Promise((resolve) => {
      this.http.get('assets/json/module.json').pipe(
        map((res: any) => {
          return res;
        })
      ).subscribe((val) => {
        this.wsclient.doInvoke((response: any) => {
          resolve({ success: true, result: response, labels: val.labels });
        },
          'lpdescribe',
          { elementTypes: JSON.stringify(val.modules) },
          'POST');
      });
    })
  }

  getRecords(type?: string) {
    var contacto = localStorage.getItem('contactid');
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lpretrieve_related',
        {
          sourceid: contacto,
          relatedType: type,
          relatedLabel: type
        },
        'POST'
      );
    });
  }

  getUsers(id?: string) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        console.log(res);
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'retrieve',
        {
          id: id,
        },
        'GET'
      );
    });
  }

  create(type?: string, entity?: any) {
    return new Promise((resolve) => {
      this.wsclient.doCreate(type, entity, (res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      });
    });
  }

  // delete(id?: string, user?: any) {
  //   console.log("ESTOY EN BORRAR: "+id)
  //   return new Promise((resolve) => {
  //     this.wsclient.doDelete(id, user, (res: any) => {
  //       if (res) {
  //         resolve({ success: true, result: res });
  //       } else {
  //         resolve({ success: false, error: this.wsclient.lastError() });
  //       }
  //     });
  //   });
  // }

  delete(id: any, ) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'delete',
        {
         id: id,
         user: this.wsclient._userid,
        },
        'POST'
      );
    });
  }

  revise(entity?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'revise',
        {
          element: this.wsclient.toJSONString(entity)
        },
        'POST'
      );
    });
  }

  portalupdateparametriza(id?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'portalupdateparametriza',
        {
          idproyecto: id
        },
        'GET'
      );
    });
  }


  lprecuperar_psw(email: any, codigo:any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lprecuperar_psw',
        {
         email: email,
         codigo: codigo
        },
        'GET'
      );
    });
  }
   

  lpchange_password(correo: any, pwd:any, pwdNew:any = null) {
    console.log( correo, pwd)
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lpchange_password',
        {
         correo: correo,
         pwd: pwd,
         pwdNew: pwdNew,
        },
        'POST'
      );
    });
  }

  changePassword(id?: any, oldPassword?: any,newPassword?: any,confirmPassword?: any,user?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'changePassword',
        {
          id: id, 
          oldPassword: oldPassword, 
          newPassword: newPassword, 
          confirmPassword: confirmPassword, 
          username: user,
        },
        'POST'
      );
    });
  }


  download_file(id?: any) {
    var contacto = (localStorage.getItem('contactid')).split("x")[1];
    console.log(contacto)
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'download_file',
        {
          id: id,
          contactid: contacto
        },
        'POST'
      );
    });
  }

  
  
  lpregistrarusuario(nombre?: any, apellido?: any, email?: any, nacionalidad?: any, cedula?: any, direccion?: any, telefono?: any, celular?: any, genero?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
      'lpregistrarusuario',
      {
        nombre: nombre,
        apellido: apellido,
        email: email,
        nacionalidad: nacionalidad,
        cedula: cedula,
        direccion: direccion,
        telefono: telefono, 
        celular: celular,
        genero: genero,
      },
      'POST'
      );
    });
  }
  

  
  lpagendar(agenda?: any, proyecto?: any, accion?: any) {
    var contacto = localStorage.getItem('contactid');
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
      'lpagendar',
      {
        agenda: agenda,
        proyecto: proyecto,
        accion: accion
      
      },
      'GET'
      );
    });
  }

  getRelatedRecords(type?: string, id?: string, labels?: string) {
    var contacto = localStorage.getItem('contactid');
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'retrieve_related',
        {
          id: id,
          relatedType: type,
          relatedLabel: labels
        },
        'GET'
      );
    });
  }

  deleterelated_documents(moduleName?: any, recordId?: any, documentId?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'deleterelated_documents',
        {
          moduleName: moduleName,
          documentId: documentId,
          recordId: recordId
        },
        'POST'
      );
    });
  }


  get wsUrl(): string {
    var url = environment.url;
    if (url.charAt(url.length - 1) != '/') url += '/';
    return url;
  }
};
